export const selectDateRules = [
  {
    type: 'object',
    required: true,
    message: 'Укажите дату',
  },
];

export const maxDescLength = 1000;
